<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import {
    isEdit,
    items,
    notifyIsAddNewItem,
    notifyModalOpen,
    notifyTypeChange,
    isLoading,
    currentItem,
  } from "./stores.js";
  import ItemCard from "./ItemCard.svelte";
  import AddItemCard from "./AddItemCard.svelte";

  export let businessCode;
  export let itemType;
  const delay = 300;

  onMount(async () => {
    await items.fetchItems(itemType, businessCode);
  });

  const handleItemCardClick = (item) => {
    // set the current item and item type for modal components
    $currentItem = item;
    notifyTypeChange(itemType);
    notifyModalOpen($isEdit ? "edit" : "book", item);
  };

  const handleAddItemCardClick = () => {
    // Set the item type for modal components
    notifyTypeChange(itemType);
    notifyIsAddNewItem(businessCode);
    notifyModalOpen("edit");
  };
</script>

{#if !$isLoading}
  <div class="row">
    {#each $items[itemType] as item, i (item.id)}
      <!-- Fade in items one-by-one, except if newly added -->
      <div
        in:fade={{ delay: item.new ? 0 : delay + i * 100, duration: 1000 }}
        class="col-6 col-md-4">
        <ItemCard
          {item}
          {itemType}
          {businessCode}
          on:click={() => handleItemCardClick(item)} />
      </div>
    {/each}
    {#if $isEdit}
      <div class="col-6 col-md-4">
        <AddItemCard {businessCode} {itemType} on:click={handleAddItemCardClick} />
      </div>
    {/if}
  </div>
{/if}
